export const KINDS_WITH_MANDATORY_ATTRIBUTES = [
  'custom',
  'inbound_call',
  'outbound_call',
  'physical'
]

export const INTEGRATIONS = [
  'zoom_conference',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference',
  'gotomeeting_conference'
]

export const PHONE_CALL_KINDS = {
  outbound: 'outbound_call',
  inbound: 'inbound_call'
}

export const NON_EXCLUSIVE_LOCATIONS = [
  'physical',
  'custom'
]

export const MOST_POPULAR_KINDS = [
  'zoom_conference',
  'outbound_call',
  'physical',
]

export const ROUND_ROBIN_MOST_POPULAR_KINDS = [
  'zoom_conference',
  'inbound_call',
  'physical',
]

export const OTHER_KINDS = [
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference',
  'gotomeeting_conference',
  'custom',
  'ask_invitee'
]

export const MAX_LOCATIONS = 10

export const NEW_POSSIBLE_KINDS = [
  'inbound_call',
  'outbound_call',
  'physical',
  'ask_invitee',
  'custom',
  'zoom_conference',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference',
  'gotomeeting_conference'
]
